import api from '../../services/api.js'
import TokenService from '../../services/tokenService.js'

const state = {
  username: null,
  role: null,
  rememberMe: null
}

const getters = {
  isAuthenticated: (state) => state.username != null,
  username: (state) => state.username,
  isAdmin: (state) => state.role === 'ROLE_ADMIN',
  isRememberMe: (state) => state.rememberMe,
};

const actions = {

  async LogIn({commit}, data) {

    await api({
      method: 'POST',
      url: '/api/login',
      data: JSON.stringify(data),
      headers: {'content-type': 'application/json'}

    }).then(response => {
      commit('didLogIn', response)
    })

  },

  refreshToken({commit}, response) {
    commit('didRefreshToken', response)
  },

  setRememberMe({commit}, rememberMe) {
    commit('setRememberMe', rememberMe)
  },

  async LogOut({commit}) {
    commit('didLogOut')
  }
}

const mutations = {

  didLogIn(state, response) {
    const role = response.data.roles[0]
    if (role === "ROLE_USER") {
      throw 'Locked';
    } else {
      TokenService.setUser(response.data)
      state.username = response.data.username
      state.role = role
    }
  },

  didRefreshToken(state, response) {
    TokenService.setUser(response.data)
  },

  didLogOut(state) {
    TokenService.removeUser()
    state.username = null
    state.role = null
  },

  setRememberMe(state, rememberMe) {
    state.rememberMe = rememberMe
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js